export const CHECKVATLIST_INVALID = 'CHECKVATLIST_INVALID';